<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'
import { instructorModule } from '@/store/instructor/module'
import { userModule } from '@/store/user/module'
import { computed, onMounted, ref } from 'vue'

const {
    Input: PocketInput,
    Button: PocketButton,
} = UIKit

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const isLoading = ref(false)
const error = ref('')

const currentOrgInstructor = computed(() => {
    return instructorModule.getters.getCurrentOrgInstructor()
})

const currentOrgInstructorUsers = computed(() => {
    return instructorModule.getters.getCurrentOrgInstructorUsers()
})

onMounted(async () => {
    await Promise.all([
        instructorModule.actions.fetchCurrentOrgInstructor(),
        instructorModule.actions.fetchCurrentOrgInstructorUsers(),
    ])

    if (!currentOrgInstructorUsers.value || !currentOrgInstructor.value) {
        throw new Error('Account: No instructor records found.')
    }

    const user = currentOrgInstructorUsers.value[currentOrgInstructor.value.user.objectId]
    firstName.value = user?.firstName || ''
    lastName.value = user?.lastName || ''
    email.value = user?.username || ''
})

const submitResetPassword = async () => {
    isLoading.value = true
    await userModule.actions.resetPassword()
    alert('Please check your email for instructions to reset your password.')
    isLoading.value = false
}

const updateAccountSettings = async () => {
    isLoading.value = true
    error.value = ''
    try {
        await userModule.actions.updateUser({
            firstName: firstName.value,
            lastName: lastName.value,
            email: email.value.toLowerCase(),
        })
    } catch (e) {
        if (typeof e === 'string') {
            error.value = e
        } else if (e instanceof Error) {
            error.value = e.message
        }
    }
    isLoading.value = false
}
</script>

<template>
    <div class="account">
        <div class="account__title">
            Account Details
        </div>
        <div id="name-email" class="account__name-email">
            <label>Name &amp; Email</label>
            <PocketInput
                v-model="firstName"
                label="First Name"
                class="account__field"
            />
            <PocketInput
                v-model="lastName"
                label="Last Name"
                class="account__field"
            />
            <PocketInput
                v-model="email"
                label="Email"
                field-type="email"
                class="account__field"
            />
            <div class="account__buttons">
                <PocketButton
                    type="secondary"
                    :disabled="isLoading"
                    @click="submitResetPassword"
                >
                    Reset Password
                </PocketButton>
                <PocketButton :disabled="isLoading" @click="updateAccountSettings">
                    Save Changes
                </PocketButton>
            </div>
            <div class="account__error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>


.account {
    label {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 37px;
        display: block;
        margin-left: 11px;
    }

    &__buttons {
        display: flex;
        justify-content: space-between;

        button:first-child {
            margin-left: -8px;
            padding: 9px 8px;
        }
    }

    &__error {
        color: $brand-red;
        margin-top: 10px;
    }

    &__title {
        font-size: 26px;
        line-height: 36px;
        font-weight: 600;
        margin-left: 11px;
        margin-bottom: 72px;
    }

    &__name-email {
        max-width: 363px;
    }

    &__field {
        margin-bottom: 14px;
    }
}
</style>
